module.exports = __webpack_public_path__ + "media/icons/repair-9f07d0e8.svg";